import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import InquiryForm from "@/components/InquiryForm";
import SEO from "@/components/SEO";
import { buildBreadcrumb } from "@/lib/schemas";

export default function GroupClassPage() {
  return (
    <>
      <SEO
        title="Request a Private Group Homestead Class"
        description="Private make-and-take homestead classes for co-ops, schools, moms' groups, and friend gatherings in Chino Valley, AZ and Yavapai County. Bread, soap, gardening, and more."
        keywords="private group homestead class Arizona, homeschool co-op field trip Yavapai County, moms night out class Chino Valley, custom homestead workshop"
        jsonLd={buildBreadcrumb([
          { name: "Home", url: "/" },
          { name: "1-on-1 & Consulting", url: "/services" },
          { name: "Private Group Class", url: "/group-class" },
        ])}
      />
      <NavBar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 sm:pt-20 pb-20">
        <header className="fade-up">
          <p className="uppercase tracking-[0.22em] text-xs sm:text-sm text-gg-brown font-semibold">
            Private group classes
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl text-[var(--gg-text)] leading-tight mt-3">
            Request a Private Group Class
          </h1>
          <p className="mt-5 text-gg-muted leading-relaxed">
            Homeschool co-ops, traditional schools, friend groups, book clubs, moms' groups, girls' nights — Heather builds make-and-take classes around your group's interests. Bread making for a girls' night. Soap making for a moms' group. Garden basics for a co-op. Tell us what you're imagining and we'll send you a quote and available dates.
          </p>
        </header>

        <div className="mt-10 fade-up d1">
          <InquiryForm
            requestType="group-class"
            testidPrefix="group"
            submitLabel="Send Group Request"
            fields={[
              {
                name: "group_type",
                label: "Group type",
                type: "select",
                required: true,
                options: [
                  { value: "homeschool-coop", label: "Homeschool co-op" },
                  { value: "traditional-school", label: "Traditional school" },
                  { value: "moms-group", label: "Moms' group" },
                  { value: "girls-night", label: "Girls' night out" },
                  { value: "book-club", label: "Book club" },
                  { value: "friends", label: "Group of friends" },
                  { value: "other", label: "Other" },
                ],
              },
              {
                name: "group_size",
                label: "Group size",
                type: "number",
                required: true,
                placeholder: "e.g. 8",
                hint: "Approximate headcount.",
              },
              {
                name: "preferred_topic",
                label: "Class topic you're imagining",
                required: true,
                placeholder: "Sourdough bread making · Goat-milk soap · Garden basics …",
              },
              {
                name: "preferred_dates",
                label: "Preferred dates / windows",
                placeholder: "e.g. weekends in March, or Sat Mar 14 evening",
                hint: "Give a couple of options to make scheduling easier.",
              },
            ]}
          />
        </div>
      </main>
      <Footer />
    </>
  );
}
